<template>
  <div>
    <span class="equity-score-badge">
      {{ props.model.equity_score }}
    </span>
  </div>
</template>



<script lang="ts" setup>
import GripLink from '~/components/GripLink.vue';
import { defineProps, ref, inject } from 'vue';
import type { ColumnDataSchemaModel } from '@revolist/vue3-datagrid';

const props = defineProps<ColumnDataSchemaModel>();
const EquityCell = ref<HTMLElement>();

const message = inject('sample');
function customCellClickEvent() {
  console.log('Custom cell click > Injected message:', message);
  const event = new CustomEvent('cell-custom-action', {
    bubbles: true,
    detail: { row: props.model },
  });
  EquityCell.value?.dispatchEvent(event);
}
</script>


<style scoped>
.equity-score-badge {
  display: inline-block;
  padding: 3px 10px;
  background: #fef3c7;
  border-radius: 6px;
  font-size: 0.93rem;
  font-weight: 600;
  color: #b45309;
}
</style>